import { jsx as _jsx } from "react/jsx-runtime";
import { createContext } from "react";
export const ConsumablesProductDetailsContext = createContext({} // useConsumablesProductDetailsContext will throw an error if this context is not provided
);
export const ConsumablesProductDetailsProvider = ({ children, data }) => {
    return _jsx(ConsumablesProductDetailsContext.Provider, { value: data, children: children });
};
//# sourceMappingURL=ConsumablesProductDetailsProvider.js.map